/**
 * engine API
 * engine API documentation
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
 import { AbstractFilterStatistics } from './abstractFilterStatistics';


 export interface StatisticsConfig { 
    cacheExpirationInMinutes?: number;
    category?: StatisticsConfig.CategoryEnum;
    code?: string;
    defaultValuesFilters?: any;
    description?: string;
    filterPartner?: Array<string>;
    filters?: Array<AbstractFilterStatistics>;
    name?: string;
    scheduleUpdate?: string;
    series?: Array<string>;
}
// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace StatisticsConfig {
    export type CategoryEnum = 'CONTACT' | 'SELL' | 'FLIGHT';
    export const CategoryEnum = {
        CONTACT: 'CONTACT' as CategoryEnum,
        SELL: 'SELL' as CategoryEnum,
        FLIGHT: 'FLIGHT' as CategoryEnum
    };
}
